import React, { Component } from 'react'
import EntityList from './../../components/entityList';
import QuoteEdit from './quoteEdit';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Checkbox from 'material-ui/Checkbox';

import SendIcon from 'material-ui/svg-icons/content/send';

import utils from '../../misc/utils';
var config = utils.getConfig();

const Styles = {
  dialogContentStyle: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '600px',
    maxWidth: 'none'    
  },
  optionsButton: {
    width: 32
  }  
};

class Quotes extends Component {
  constructor(props, context) {
    super(props, context);

    this.afterSave = this.afterSave.bind(this);
    this.onOptionsSelected = this.onOptionsSelected.bind(this);
    this.openOptionsDialog = this.openOptionsDialog.bind(this);
    this.onSendEmailCheckedChanged = this.onSendEmailCheckedChanged.bind(this);
    this.onPrintCheckedChanged = this.onPrintCheckedChanged.bind(this);
    this.printReport = this.printReport.bind(this);

    this.state = {
      isQuoteOptionsOpened: false,
      currentEntityIDOptions: null,
      currentEntityOptionsValues: {}
    };
  }

  afterSave(id, cloneEntity, currentEntity, successCallback){
    if(cloneEntity.Images){
      cloneEntity.Images.map((image, i) => {
        image.Sequence = i;

        if(image.State){      
          switch(image.State){
            case 'added':              
              image.ExID = id;
              utils.postDataToApi('api/quotes/' + id + '/images', image, null, null);
            break;
            case 'deleted':
              if(Number.isInteger(image.ID)){
                utils.deleteFromApri('api/quotes/' + id + '/images/' + image.ID, null, null);
              }
            break;
          }
        }
        else{
          if(Number.isInteger(image.ID)){
            utils.putDataToApi('api/quotes/' + id + '/images/' + image.ID, image, null);
          }
        }        
      });
    }

    this.openOptionsDialog(cloneEntity, id);
    successCallback();    
  }

  onOptionsSelected(){
    if(this.state.currentEntityIDOptions){
      var id = this.state.currentEntityIDOptions;
      if(this.state.currentEntityOptionsValues.SendEmail){
        utils.getDataFromApi('api/quotes/' + id + '?action=send', null, null);
      }
      if(this.state.currentEntityOptionsValues.Print){
        utils.getHTMLFromApi('api/quotes/' + id + '?action=report', (result) => {
          this.printReport(result.body.getReader(), '');   
        }, null);
      }
    }

    this.setState({
      isQuoteOptionsOpened: false,
      currentEntityIDOptions: null,
      currentEntityOptionsValues: {}
    });    
  }

  printReport(reader, content){
    reader.read().then((result) => {
      content += utils.uintToString(result.value);

      if(result.done){
        var iframe = document.createElement('iframe');
        iframe.width = '0';
        iframe.height = '0';
        iframe.src = 'about:blank';            
        document.body.appendChild(iframe);
        iframe.contentWindow.contents = content;
        iframe.src = 'javascript:window["contents"]';
        iframe.focus();
        iframe.onload = () => {
          iframe.contentWindow.print();
          setTimeout(() => {                
            document.body.removeChild(iframe);
          }, 0);
        }         
      }
      else
        this.printReport(reader, content);
    });
  }

  openOptionsDialog(entity, id){
    if(!id)
      id = entity.ID

    this.setState({
      isQuoteOptionsOpened: true,
      currentEntityIDOptions: id,
      currentEntityOptionsValues: {}
    });
  }

  onSendEmailCheckedChanged(e, isInputChecked){
    this.state.currentEntityOptionsValues.SendEmail = isInputChecked;
    this.setState({
      currentEntityOptionsValues: this.state.currentEntityOptionsValues
    });
  }

  onPrintCheckedChanged(e, isInputChecked){
    this.state.currentEntityOptionsValues.Print = isInputChecked;
    this.setState({
      currentEntityOptionsValues: this.state.currentEntityOptionsValues
    });
  }

  render() {    
    return (
      <div>
        <EntityList apiRoute='api/quotes' baseCriteria={'count=1000&scope=' + (this.state.scope ? this.state.scope : 'active')} editComponent={QuoteEdit} title='Soumissions' editTitle='Soumission' afterSave={this.afterSave} defaultOrderBy='-ID' displayColumns={[          
          {Description: '#', Column: 'ID'},
          {Description: 'Client', Column: 'CustomerName'},
          {Description: 'Compagnie', Column: 'Company'},
          {Description: 'Préparé par', Column: 'User', format: {type: 'relation', displayColumn: 'Name'}},
          {Description: 'Envoyé le', Column: 'SentDateValue', format: {type: 'datetime'}},          
          {Description: '', sortable: false, dataAlias: '', style: Styles.optionsButton, format: {type: 'button', action: this.openOptionsDialog, content: <SendIcon/> }}          
        ]}/>

        <Dialog
          title='Options' 
          contentStyle={Styles.dialogContentStyle}
          open={this.state.isQuoteOptionsOpened}
          actions={
            [         
              <FlatButton
                label="Ok"
                primary={true}
                keyboardFocused={true}
                onTouchTap={this.onOptionsSelected}
              />,
            ]              
          }>
          <div>
            <Checkbox 
              label='Envoyer par courriel' 
              checked={this.state.currentEntityOptionsValues.SendEmail ? this.state.currentEntityOptionsValues.SendEmail : false}
              onCheck={this.onSendEmailCheckedChanged} />
            <Checkbox 
              label='Imprimer' 
              checked={this.state.currentEntityOptionsValues.Print ? this.state.currentEntityOptionsValues.Print : false}
              onCheck={this.onPrintCheckedChanged}/>
          </div>
        </Dialog>
      </div> 
    )
  }
}

export default Quotes;


/** WEBPACK FOOTER **
 ** ./src/app/routes/quotes/quotes.js
 **/